import WhatsAppSipDidsAPI from 'dashboard/api/whatsappSip/dids';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(r => r.id === id),
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipDidsAPI.get();
      const dids = data.dids || data || [];
      commit('SET_RECORDS', dids);
      return dids;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const { data } = await WhatsAppSipDidsAPI.show(id);
    return data.did || data;
  },

  async create({ commit }, didData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsAppSipDidsAPI.create(didData);
      const did = data.did || data;
      commit('ADD_RECORD', did);
      return did;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data: updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsAppSipDidsAPI.update(id, updateData);
      const did = data.did || data;
      commit('UPDATE_RECORD', did);
      return did;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsAppSipDidsAPI.delete(id);
      commit('DELETE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  ADD_RECORD($state, record) {
    $state.records = [record, ...$state.records];
  },

  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
